import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const CareerRequestsEdit = props => (
  <Edit {...props} resource="careerRequests">
    <Form />
  </Edit>
);

CareerRequestsEdit.propTypes = {};

export default CareerRequestsEdit;
